
import { computed } from 'vue';
import { useAuthStore } from '@/shared/stores/auth';
import { useProfileStore } from '@/shared/stores/profile';
import { useProjectStore } from '@/shared/stores/project';
import { resolveEffectiveUserRole } from '@/shared/utils/projectAccess';

/**
 * Returns the user's effective role for the currently loaded/selected project.
 * - If the user is a System Administrator, always returns SystemAdministrator.
 * - Otherwise, returns the user's role for the selected project (ProjectOwner, ProjectContributor, ProjectViewer),
 *   or SystemUser if no project or no role.
 */
export function useUserRole() {
  const authStore = useAuthStore();
  const profileStore = useProfileStore();
  const projectStore = useProjectStore();

  const selectedProject = computed(() => projectStore.getProjectById(projectStore.selectedProjectId));

  const userRole = computed(() => {
    const userId = profileStore.profile.id || authStore.user?.id || null;

    return resolveEffectiveUserRole({
      projects: selectedProject.value ? [selectedProject.value] : projectStore.projects,
      selectedProjectId: projectStore.selectedProjectId,
      systemRole: authStore.user?.systemRole ?? null,
      userId,
    });
  });

  return {
    userRole,
  };
}
